import CryptoJS from 'crypto-js'

const secretKey = import.meta.env.VITE_SECRET_KEY

export const encrypt = (text: string) => CryptoJS.AES.encrypt(text, secretKey).toString()
export const decrypt = (text: string) =>
  CryptoJS.AES.decrypt(text, secretKey).toString(CryptoJS.enc.Utf8)
